var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":"text"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"iconfont icon-fanhui"}),_vm._v(" "+_vm._s(_vm.$t('fan_hui')))])}
var staticRenderFns = []

export { render, staticRenderFns }